import { useQuery } from "react-query";
import type { PaginatedFilter } from "../types/axios.types";
import {
	fetchMaterialLogsPaginated,
	fetchMaterialsByLabel,
	fetchMaterialsPaginated,
} from "../queries/material.queries";

export const useMaterialsPaginated = (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const query = useQuery(
		["materials-paginated", page, size, search, filters, sortBy],
		() => {
			try {
				return fetchMaterialsPaginated(page, size, search, filters, sortBy);
			} catch (err) {
				return null;
			}
		},
		{ keepPreviousData: true },
	);
	return query?.data;
};

export const useMaterialLogsPaginated = (
	id?: string | number,
	page?: number,
	size?: number,
) => {
	const query = useQuery(
		["materials-logs-paginated", id, page, size],
		() => {
			try {
				return fetchMaterialLogsPaginated(id, page, size);
			} catch (err) {
				return null;
			}
		},
		{ keepPreviousData: true },
	);
	return query?.data;
};

export const useMaterialByLabel = (label: string | null | undefined) => {
	const query = useQuery(
		["materials", "labels", label],
		() => {
			if (!label) return;
			return fetchMaterialsByLabel(label);
		},
		{ enabled: !!label, keepPreviousData: true },
	);
	return query?.data;
};
